import { render } from "./CustomerHistory.vue?vue&type=template&id=4ef68cb2"
import script from "./CustomerHistory.vue?vue&type=script&lang=ts"
export * from "./CustomerHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script